import throttle from '@utils/throttle';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setWindowWidth } from '../redux/viewport';

const useViewportSync = () => {
	const dispatch = useDispatch();

	useEffect(() => {
		const throttleResize = throttle(
			() => dispatch(setWindowWidth(window.innerWidth)),
			500,
		);

		window.addEventListener('resize', throttleResize);

		return () => {
			window.removeEventListener('resize', throttleResize);
		};
	}, [dispatch]);
};

export { useViewportSync };
